import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { IState, ISuccessAction, IFailureAction } from 'interfaces/list-duck';
import { IConfig } from 'interfaces/config';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess'],
    success: ['data'],
    failure: ['error'],
    reset: [],
  },
  { prefix: 'LIST_DATATABLE_COLUMN_CONFIGS_' }
);

export interface ListDatatableColumnConfigsState extends IState {
  data: IConfig[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: IConfig[];
}

const INITIAL_STATE: ListDatatableColumnConfigsState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListDatatableColumnConfigsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: ListDatatableColumnConfigsState,
  action: ISuccessListUnitsAction
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListDatatableColumnConfigsState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listDatatableColumnConfigs = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListDatatableColumnConfigsTypes = Types;
export const ListDatatableColumnConfigsActions = Creators;
